define(["require", "exports"], function (require, exports) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    exports.TravelSegmentTypeDomain = void 0;
    class TravelSegmentTypeDomain {
        static initialise() {
            if (!this.isInitialised) {
                this.isInitialised = true;
                this.values = [
                    { key: TravelSegmentTypeDomain.SingleShireTravel, value: "Single Shire Travel" },
                    { key: TravelSegmentTypeDomain.MultipleShireTravelOriginatingShire, value: "Multiple Shire Travel (Originating Shire)" },
                    { key: TravelSegmentTypeDomain.MultipleShireTravelNonOriginatingShire, value: "Multiple Shire Travel (Non-Originating Shire)" }
                ];
                this.KeyIndex = {};
                this.KeyIndex[TravelSegmentTypeDomain.SingleShireTravel] = 0;
                this.KeyIndex[TravelSegmentTypeDomain.MultipleShireTravelOriginatingShire] = 1;
                this.KeyIndex[TravelSegmentTypeDomain.MultipleShireTravelNonOriginatingShire] = 2;
                this.ValueIndex = {};
                this.ValueIndex["Single Shire Travel"] = 0;
                this.ValueIndex["Multiple Shire Travel (Originating Shire)"] = 1;
                this.ValueIndex["Multiple Shire Travel (Non-Originating Shire)"] = 2;
            }
        }
        static get Values() {
            this.initialise();
            return this.values;
        }
        static findByValue(value) {
            this.initialise();
            if (this.ValueIndex[value] != null) {
                return this.Values[this.ValueIndex[value]];
            }
            return null;
        }
        static findByKey(key) {
            this.initialise();
            if (this.KeyIndex[key] != null) {
                return this.Values[this.KeyIndex[key]];
            }
            return null;
        }
    }
    exports.TravelSegmentTypeDomain = TravelSegmentTypeDomain;
    Object.defineProperty(TravelSegmentTypeDomain, "SingleShireTravel", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: 0
    });
    Object.defineProperty(TravelSegmentTypeDomain, "MultipleShireTravelOriginatingShire", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: 1
    });
    Object.defineProperty(TravelSegmentTypeDomain, "MultipleShireTravelNonOriginatingShire", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: 2
    });
    Object.defineProperty(TravelSegmentTypeDomain, "isInitialised", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: false
    });
});
